// extracted by mini-css-extract-plugin
export default {"button":"SelectionActionButton_button__mpffZDgd","icon":"SelectionActionButton_icon__W+t4to2X","text":"SelectionActionButton_text__7r1WsLEB"};